<div class="ickahra kareli">
  <div class="sar">
    <p class="etiket">Eğitim kurumları</p>
    <h1 class="h1" style="margin-top:16px">Kalite raporu değil, <span class="vurgu">kazanım haritası</span>.</h1>
    <p class="giris-p">Kurumunuzun hangi kazanımı öğrettiğini biliyorsunuz. pratiu, öğrencilerin hangi kazanımı üç ay sonra hâlâ hatırladığını gösterir. Müfredat kararlarınızı bu ikinci veriyle alın.</p>
    <div class="hero-btn">
      <a class="btn kirmizi" href="https://app.pratiu.com" target="_blank" rel="noopener">Hemen kayıt olun <svg><use xlink:href="#i-ok"></use></svg></a>
      <a class="btn ikincil" routerLink="/contact">Kurum demosu isteyin</a>
    </div>
    <div class="sayac">
      <div><span class="sayi">%41</span><span class="etiket">daha az tekrar süresi</span></div>
      <div><span class="sayi">14 gün</span><span class="etiket">ilk kazanım haritası</span></div>
      <div><span class="sayi">Sınırsız</span><span class="etiket">şube ve öğretmen</span></div>
    </div>
  </div>
</div>

<div class="sar bol">
  <div class="aciklama">
    <div>
      <span class="etiket">Sorun</span>
      <h2 class="h2" style="margin:14px 0 18px">Deneme ortalaması yükselirken kalıcılık düşebilir.</h2>
      <p>Klasik ölçme, konu işlendikten hemen sonra yapılır. Bu, öğrencinin öğrendiğini değil, en son ne çalıştığını ölçer. Dönem sonunda net düşünce sebebi bulunamaz.</p>
      <p>pratiu her kazanımı düzenli aralıklarla yeniden yoklar. Böylece kurum, bir kazanımın gerçekten yerleşip yerleşmediğini haftalarca sonra da görür. Zümre toplantısına ortalama yerine kazanım kırılımıyla girersiniz.</p>
    </div>
    <div>
      <span class="etiket">Kurumun aldığı</span>
      <ul class="tik" style="margin-top:16px">
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Kazanım ısı haritası</b> — sınıf, şube, öğretmen ve dönem kırılımında hangi kazanımın çürüdüğü.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Kalıcılık endeksi</b> — konu bittikten 30 ve 90 gün sonraki hatırlama oranı.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>Ortak soru bankası</b> — kurum arşivini tüm zümreye açın, öğretmen tek tek soru yazmasın.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>LGS &amp; YKS özgün soruları</b> — kazanıma göre yazılmış, sınav formatında yeni sorular.</span></li>
        <li><svg><use xlink:href="#i-tik"></use></svg><span><b>KVKK uyumlu kurulum</b> — veli erişimi opsiyonel, veri yurt içinde.</span></li>
      </ul>
    </div>
  </div>
</div>

<div style="border-top:1px solid var(--cizgi)">
  <div class="sar bol ince">
    <div class="oz-liste">
      <div><span class="etiket">01</span><h4 class="h4">Kazanımlara dayalı periyodik sınavlar</h4><p>Öğrenme sürecini tek seferlik değil, dönem boyunca düzenli ölçün.</p></div>
      <div><span class="etiket">02</span><h4 class="h4">Detaylı performans analizleri</h4><p>Her sınav sonrası zayıf kazanımı öğrenci bazında görün.</p></div>
      <div><span class="etiket">03</span><h4 class="h4">Sürekli geri bildirim</h4><p>Öğretmen ve öğrenci gelişimini aynı ekrandan izleyin.</p></div>
      <div><span class="etiket">04</span><h4 class="h4">Müfredat güncelleme</h4><p>Kalıcılık verisi düşük kazanımlar için ders planını revize edin.</p></div>
    </div>
  </div>
</div>

<div class="cta">
  <div class="cta-ic">
    <div><h2 class="h2">Kurumunuz için haritayı çıkaralım.</h2><p>14 günde ilk kazanım raporunu birlikte üretelim.</p></div>
    <a class="btn kirmizi" routerLink="/contact">Demo talep edin <svg><use xlink:href="#i-ok"></use></svg></a>
  </div>
</div>
